import { MessageCircle, Users } from "lucide-react";
import { Button } from "@/components/ui/button";

const DiscordCommunity = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-background to-muted/30">
      <div className="page-container mx-auto py-12 space-y-8">
        <div className="glass-card p-8 space-y-4">
          <div className="w-12 h-12 rounded-2xl bg-gradient-to-br from-primary to-secondary flex items-center justify-center">
            <MessageCircle className="w-6 h-6 text-white" />
          </div>
          <h1 className="text-3xl font-bold">Discord Community</h1>
          <p className="text-muted-foreground">
            Unisciti al server ufficiale per supporto, news e aggiornamenti in tempo reale.
          </p>
          <Button className="gap-2">
            <Users className="w-4 h-4" />
            Entra su Discord
          </Button>
        </div>
      </div>
    </div>
  );
};

export default DiscordCommunity;
